<template lang="html">
  <div class="ui message">
    <span v-for="riga in this.config.help" v-html="riga"></span>
  </div>
</template>

<script>

export default {
  name: 'semanticHelp',
  components: {
  },
  computed: {
    config: function() {
      return this.$store.getters.getObject(this.id).data;
    },
  },
  props: {
    id: String,
  },
  data() {
    return {
    }
  },
  mounted: function() {
  },
  async created() {
  },
  methods: {
  }
}
</script>

<style scoped>
</style>
